<template>
	<div class="column-list" v-if="columnFlag">
		<div class="introduction">
			<img :src="columnInfo.banner" alt="">
			<div class="brief">
				<div class="name">
					<span>{{columnInfo.name}}</span>
					<!-- <i>{{columnInfo.follow_user_count}} 关注</i> -->
				</div>
				<!-- <div class="attentionBtn" @click="changeStatus">
					<van-icon :name="columnInfo.statusIcon"/> {{columnInfo.statusText}}
				</div> -->
			</div>
		</div>
		<div class="articleList">
			<template v-for="item in articleList">
				<item-block :itemContent="item" :key="item.id"></item-block>
			</template>
		</div>
	</div>
</template>
<script>
	import {ColumnDetails,ColumnFollow,CertificatesCheck,ButtonDetail} from '../../config/interface.js';
	import ItemBlock from "../../components/ItemBlock" 
	export default{
		components:{
			ItemBlock
		},
		data(){
			return {
				columnFlag:false,			//专栏展示
				column_id:0,				//专栏id
				columnInfo:{},				//专栏信息
				articleList:[],				//文章列表
				button_id:this.$route.query.button_id,
			}
		},
		// beforeRouteEnter(to, from, next) {
        //     //  修复iOS版微信HTML5 History兼容性问题
        //     if (to.path !== location.pathname) {
        //         // 此处不可使用location.replace
        //         location.assign(to.fullPath)
        //     } else {
        //         next()
        //     }
        // },
		mounted(){
			this.column_id=this.$route.query.id;
			this.init();
		},
		methods:{
			//专栏详情
			init(){
				const url=ColumnDetails;
				const method='POST';
				let params={
					column_id:this.column_id
				};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						if(data.is_follow==0){
							//表示未关注
							data.statusText="关注"
							data.statusIcon="plus";
						}else{
							//表示关注
							data.statusText="已关注"
							data.statusIcon="success";						
						}
						this.columnInfo=data;
						data.articles.forEach(function(item,index){
							item.readnum=data.readnum[item.id]
						})
						this.articleList=data.articles;
						document.title=data.name;
						//微信浏览器  请求jsdk
						if(common.is_weixin()){
							if(this.button_id){
								this.getButtonData();

							}
							else{
								common.wxShare(data.name,'',data.share_img);


							}
							if(data.check_certificates==1){
								this.isUploadCert(); 
							}else{
								this.columnFlag=true;
							}
						}else{
							this.columnFlag=true;
						}
						
					}
				})
			},
			//获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			},
			//检验用户有没有上传证书
			isUploadCert(){
				const url=CertificatesCheck;
				const method='POST';
				let params={
					type:[0]
				}
				fetch(url,params,method).then((res)=>{
					if(res.code==0){
						let data=res.data;
						let user_certificates=data.user_certificates;
						if(user_certificates.length==0||user_certificates[0].status!=1){
							// 需要上传职业职业资格证
							this.$router.push({
								path:'/uploadCert'
							})
						}else{
							this.columnFlag=true;
						}
					}
				})
				
			},
			//关注或者取消专栏
			changeStatus(){
				const url=ColumnFollow;
				const method='POST';
				let params={
					column_id:this.column_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.init();
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.column-list{
		.introduction{
			padding:14px 12px;
			border-bottom:1px solid #eaeaea;
			img{
				width:100%;
				border-radius:5px;
			}
			.brief{
				@include flex(row);
				justify-content:space-between;
				align-items:center;
				.name{
					span{
						display:block;
						font-size:17px;
						color:#090909;
						line-height:40px;
					}
					i{
						font-size:12px;
						font-style: normal;
						color:#999;
					}
				}
				.attentionBtn{
					font-size:12px;
					color:#fff;
					padding:4px 7px;
					background: #901D22;
					border-radius: 2px;
					.van-icon{
						vertical-align:-1.5px;
					}
				}
			}	
		}
		.articleList{
			padding:0 12px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Column/details.vue